import type { BarChatState } from '../state-mapping';

/**
 * FRONT-3223: the two style pieces the reworked top bar (FRONT-3144) dropped
 * from `../state-style.ts`, kept for the `eddy.ui-refactoring` OFF path exactly
 * as they were on `origin/main`. Everything else the legacy bar needs
 * (`STATE_COLOR_CLASS`, `STATE_GROUP_LABEL`, `STATE_PILL_LABEL`) is unchanged
 * and still imported from `../state-style`.
 */

/** The board header's per-state count pill — explicit per state (not
 *  derived from `STATE_COLOR_CLASS` + an opacity modifier on `currentColor`,
 *  which is a fragile combination) so every soft background is unambiguous.
 *  Only the four states the header ever shows a pill for. */
export const STATE_PILL_CLASS: Record<'asking' | 'running' | 'ready' | 'stalled', string> = {
  asking: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  running:
    'eddy-tb-pill--running border border-[var(--eddy-blue-line)] bg-[var(--eddy-blue-soft)] text-[var(--eddy-blue)]',
  ready: 'bg-success/15 text-success',
  stalled: 'bg-destructive/15 text-destructive',
};

/** The board row's hover action chip — matches `actionVerbFor` in
 *  `state-mapping.ts`: warn tint for "Answer", neutral otherwise. */
export function actionChipClass(state: BarChatState): string {
  if (state === 'asking') return 'bg-amber-500/10 text-amber-600 dark:text-amber-400';
  return 'border border-[var(--line)] bg-[var(--bg-1)] text-[var(--ink-1)]';
}
